import PropTypes from "prop-types";
// @mui
import {
  Card,
  Typography,
  CardHeader,
  CardContent,
  Divider,
  Stack,
} from "@mui/material";
import { fDateTime } from "src/utils/formatTime";
// redux

// ----------------------------------------------------------------------

ShippingAddressInfo.propTypes = {
  selectedAddress: PropTypes.string,
};

export default function ShippingAddressInfo({
  row,
  shipingdetail,
  paymetInfo,
}) {
  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h5" mb={2}>
          Customer Info
        </Typography>
        <Typography variant="h6">
          {row?.firstName} {row?.lastName}
        </Typography>
        <Typography variant="body2" gutterBottom>
          Phone: {row?.mobile}
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" mb={2}>
          Shipping Address
        </Typography>
        <Typography variant="body2" gutterBottom>
          {shipingdetail?.address1} {shipingdetail?.address2},{" "}
          {shipingdetail?.city} {shipingdetail?.stateName},{shipingdetail?.pin}
        </Typography>
        <Typography variant="body2" gutterBottom>
          Phone: {row?.mobile}
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" mb={2}>
          Delivery Method
        </Typography>
        <Typography variant="body2" gutterBottom>
          {shipingdetail?.name}
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" mb={2}>
          Payment Detail
        </Typography>
        <Stack direction={"row"} justifyContent={"space-between"} mb={1}>
          <Typography
            fontSize={20}
            variant="body2"
            sx={{ color: theme => theme.palette.grey[700] }}
          >
            Payment Mode
          </Typography>
          <Typography variant="subtitle2" fontSize={16}>
            {paymetInfo?.paymentMode === "COD" ? "COD" : "Online"}
          </Typography>
        </Stack>
        {paymetInfo?.paymentMode !== "COD" && (
          <>
            <Stack direction={"row"} justifyContent={"space-between"} mb={1}>
              <Typography
                variant="body2"
                sx={{ color: theme => theme.palette.grey[700] }}
              >
                Status
              </Typography>
              <Typography variant="subtitle2">
                {paymetInfo?.status === "Shipped"
                  ? "Paid Online"
                  : paymetInfo?.status}
              </Typography>
            </Stack>
            <Stack direction={"row"} justifyContent={"space-between"} mb={1}>
              <Typography
                variant="body2"
                sx={{ color: theme => theme.palette.grey[700] }}
              >
                Ref Number
              </Typography>
              <Typography variant="subtitle2">
                {paymetInfo?.bankRefNo}
              </Typography>
            </Stack>
            <Stack direction={"row"} justifyContent={"space-between"} mb={1}>
              <Typography
                variant="body2"
                sx={{ color: theme => theme.palette.grey[700] }}
              >
                Tracking Id
              </Typography>
              <Typography variant="subtitle2">
                {paymetInfo?.trackingID}
              </Typography>
            </Stack>
            <Stack direction={"row"} justifyContent={"space-between"} mb={1}>
              <Typography
                variant="body2"
                sx={{ color: theme => theme.palette.grey[700] }}
              >
                Payment Date
              </Typography>
              <Typography variant="subtitle2">
                {paymetInfo?.createdDate
                  ? fDateTime(paymetInfo?.createdDate)
                  : "-"}
              </Typography>
            </Stack>
            <Stack direction={"row"} justifyContent={"space-between"} mb={1}>
              <Typography
                variant="body2"
                sx={{ color: theme => theme.palette.grey[700] }}
              >
                Payment Method
              </Typography>
              <Typography variant="subtitle2">
                {paymetInfo?.paymentMode}
              </Typography>
            </Stack>
          </>
        )}
        {paymetInfo?.faliureMessage && (
          <Stack direction={"row"} justifyContent={"space-between"} mb={1}>
            <Typography
              variant="body2"
              sx={{ color: theme => theme.palette.grey[700] }}
            >
              Faliure Message
            </Typography>
            <Typography variant="subtitle2">
              {paymetInfo?.faliureMessage}
            </Typography>
          </Stack>
        )}
      </CardContent>
    </Card>
  );
}
